import type { StandardEquipmentCatalogue } from "../../../configurator";
import type { StandardEquipmentCatalogueFormValues } from "../../../web-app";

export function catalogueToFormValues(
  catalogue: StandardEquipmentCatalogue,
): StandardEquipmentCatalogueFormValues {
  return {
    powerSources: catalogue.powerSources.map((powerSource) => ({
      id: powerSource.id,
      name: powerSource.name,
      powerSourceRatingKva: String(powerSource.powerSourceRatingKva),
      powerSourceFrequencyHz: String(powerSource.powerSourceFrequencyHz),
      maximumPowerSourceVoltageV: String(powerSource.maximumPowerSourceVoltageV),
      maximumPowerSourceCurrentA: String(powerSource.maximumPowerSourceCurrentA),
      minimumPowerUtilization: String(powerSource.operatingLimits.minimumPowerUtilization),
      maximumPowerUtilization: String(powerSource.operatingLimits.maximumPowerUtilization),
    })),
    coilFrames: (catalogue.coilFrames ?? []).map((coilFrame) => ({
      id: coilFrame.id,
      name: coilFrame.name,
      coilFrameSizeInches: String(coilFrame.coilFrameSizeInches),
      coilFrameInsideDiameterMm: String(coilFrame.coilFrameInsideDiameterMm),
    })),
    bottomEnds: (catalogue.bottomEnds ?? []).map((bottomEnd) => ({
      id: bottomEnd.id,
      name: bottomEnd.name,
      numberOfTurns: String(bottomEnd.numberOfTurns),
      firstContactEdgeOffsetMm: String(bottomEnd.firstContactEdgeOffsetMm),
      lastContactEdgeOffsetMm: String(bottomEnd.lastContactEdgeOffsetMm),
      contactCenterSpacingsMm: bottomEnd.contactCenterSpacingsMm.join(", "),
      bottomEndWidthMm: String(bottomEnd.bottomEndWidthMm),
      heatingResponseCelsiusMeterPerKwMinute: String(
        bottomEnd.heatingResponseCelsiusMeterPerKwMinute,
      ),
    })),
  };
}

export function formValuesEqual(
  left: StandardEquipmentCatalogueFormValues,
  right: StandardEquipmentCatalogueFormValues,
): boolean {
  return JSON.stringify(left) === JSON.stringify(right);
}
